<template>
  <div class="pa-3">
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{$t(page+'.'+message)}}</span>
    </v-snackbar>
    <v-row v-if="!form">
      <v-col class="text-center">
        <v-progress-linear
          color="info"
          height="10"
          indeterminate
          striped
        ></v-progress-linear>
      </v-col>
    </v-row>
    <v-row class="pb-3" v-else>
      <v-col>
        <v-card class="neu-glow ">
          <v-card-title primary-title>
            <div class="text-h5">Dati Fatturazione<span class="subtitle-1 red--text lighten-3 ml-2">(obbligatori)</span></div>
            <v-spacer></v-spacer>
            <v-div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :disabled="form_hash==JSON.stringify(form)"  :loading="loading_update"  @click.stop="saveItems()">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>              
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                           
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  :loading="loading"  @click.stop="getData('refresh')">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>              
            </v-div>               
          </v-card-title>
          <v-row class="px-4">
              <v-col cols="12">
                <v-text-field
                    color="primary"
                    label="Ragione Sociale"
                    outlined
                    clearable
                    name="company"
                    v-model="form.company"
                    :error-messages="fieldErrors('form.company')"
                    @blur="$v.form.company.$touch()"
                    required
                    filled
                    readonly
                    background-color="#ff000010"
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    color="primary"
                    label="Indirizzo"
                    outlined
                    clearable
                    readonly
                    name="address"
                    v-model="form.address"
                    :error-messages="fieldErrors('form.address')"
                    @blur="$v.form.address.$touch()"
                    required
                    filled
                    background-color="#ff000010"
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    color="primary"
                    label="CAP"
                    outlined
                    clearable
                    name="postalCode"
                    counter="5"
                    v-model="form.postalCode"
                    :error-messages="fieldErrors('form.postalCode')"
                    @blur="$v.form.postalCode.$touch()"
                    required
                    filled
                    background-color="#ff000010"
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    color="primary"
                    label="Sigla Provincia"
                    outlined
                    counter="2"
                    clearable
                    readonly
                    background-color="#ff000010"
                    name="stateOrProvince"
                    v-model="form.stateOrProvince"
                    :error-messages="fieldErrors('form.stateOrProvince')"
                    @blur="$v.form.stateOrProvince.$touch()"
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="9">
                <v-text-field
                    color="primary"
                    label="Città"
                    outlined
                    clearable
                    readonly
                    name="city"
                    v-model="form.city"
                    :error-messages="fieldErrors('form.city')"
                    @blur="$v.form.city.$touch()"
                    required
                    filled
                    background-color="#ff000010"
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-select
                    color="primary"
                    label="Nazione"
                    v-model="form.countryCode"
                    required
                    outlined
                    readonly
                    filled
                    background-color="#ff000010"
                    name="countryCode"
                    :items="countries"
                    :error-messages="fieldErrors('form.countryCode')"
                    @blur="$v.form.countryCode.$touch()"
                    hide-details
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    color="primary"
                    label="Codice Fiscale"
                    outlined
                    clearable
                    name="companyId"
                    filled
                    readonly
                    counter="16"
                    background-color="#ff000010"
                    v-model="form.companyId"
                    :error-messages="fieldErrors('form.companyId')"
                    @blur="$v.form.companyId.$touch()"
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    color="primary"
                    label="Partita IVA"
                    outlined
                    clearable
                    name="VATNumber"
                    v-model="form.VATNumber"
                    :error-messages="fieldErrors('form.VATNumber')"
                    @blur="$v.form.VATNumber.$touch()"
                    counter="11"
                    required
                    readonly
                    filled
                    background-color="#ff000010"
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    color="primary"
                    label="Codice SDI"
                    outlined
                    clearable
                    counter="7"
                    name="SDI"
                    v-model="form.SDI"
                    :error-messages="fieldErrors('form.SDI')"
                    @blur="$v.form.SDI.$touch()"
                    filled
                    background-color="#ff000010"
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    color="primary"
                    label="PEC"
                    outlined
                    clearable
                    counter="64"
                    name="PEC"
                    v-model="form.PEC"
                    :error-messages="fieldErrors('form.PEC')"
                    @blur="$v.form.PEC.$touch()"
                    hide-details
                    filled
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    color="primary"
                    label="IBAN"
                    outlined
                    clearable
                    counter="31"
                    name="IBAN"
                    v-model="form.IBAN"
                    :error-messages="fieldErrors('form.IBAN')"
                    @blur="$v.form.IBAN.$touch()"
                    filled
                    required
                    background-color="#ff000010"
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    color="primary"
                    label="Email"
                    outlined
                    clearable
                    counter="60"
                    name="email"
                    v-model="form.email"
                    :error-messages="fieldErrors('form.email')"
                    @blur="$v.form.email.$touch()"
                    filled
                    required
                    background-color="#ff000010"
                    hide-details
                ></v-text-field>
              </v-col>                
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="neu-glow">
          <v-card-title primary-title>
            <div class="text-h5">Dati Accounts Social</div>
            <v-spacer></v-spacer>
            <v-div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :disabled="form_hash==JSON.stringify(form)" :loading="loading_update" @click.stop="saveItems()">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>              
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                           
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData('refresh')">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>              
            </v-div>                
          </v-card-title>
          <v-row class="px-4">
              <v-col cols="12">
                <v-text-field
                    color="primary"
                    label="URL Facebook"
                    outlined
                    dense
                    clearable
                    name="facebookURL"
                    v-model="form.facebookURL"
                    @blur="$v.form.facebookURL.$touch()"
                    filled
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    color="primary"
                    label="URL Instagram"
                    outlined
                    dense
                    clearable
                    name="instagramURL"
                    v-model="form.instagramURL"
                    @blur="$v.form.instagramURL.$touch()"
                    filled
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    color="primary"
                    label="URL Twitter"
                    outlined
                    dense
                    clearable
                    name="twitterURL"
                    v-model="form.twitterURL"
                    @blur="$v.form.twitterURL.$touch()"
                    filled
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    color="primary"
                    label="URL LinkedIn"
                    outlined
                    dense
                    clearable
                    name="linkedinURL"
                    v-model="form.linkedinURL"
                    @blur="$v.form.linkedinURL.$touch()"
                    filled
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    color="primary"
                    label="URL YouTube"
                    outlined
                    dense
                    clearable
                    name="youTubeURL"
                    v-model="form.youtubeURL"
                    @blur="$v.form.youtubeURL.$touch()"
                    filled
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    color="primary"
                    label="Facebook Account Username"
                    outlined
                    dense
                    clearable
                    name="facebookusername"
                    v-model="form.facebookUsername"
                    @blur="$v.form.facebookUsername.$touch()"
                    filled
                    hide-details
                ></v-text-field>
              </v-col> 
              <v-col cols="6">
                <v-text-field
                    color="primary"
                    label="Facebook Account Password"
                    outlined
                    dense
                    clearable
                    name="facebookpassword"
                    v-model="form.facebookPassword"
                    @blur="$v.form.facebookPassword.$touch()"
                    filled
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                    color="primary"
                    label="WhatsApp Phone Number"
                    outlined
                    dense
                    clearable
                    name="whatsappNumber"
                    v-model="form.whatsappNumber"
                    @blur="$v.form.whatsappNumber.$touch()"
                    filled
                    hide-details
                ></v-text-field>          
              </v-col>                         
          </v-row>
        </v-card> 
      </v-col>   
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { availableCountries  } from "@/config/countries";
import _ from 'lodash'
const defaultForm = {
  company: "",
  address: "",
  postalCode: "",
  city: "",
  stateOrProvince: "",
  countryCode: "",
  companyId: "",
  VATNumber: "",
  SDI: "",
  PEC:"",
  IBAN:"",
  facebookUrl:"",
  instagramUrl:"",
  twitterUrl:"",
  linkedinUrl:"",
  youtubeUrl:"",
  payPalEmail:"",
  facebookUsername:"",
  facebookPassword:"",
  whatsappPhone:""
};

export default {
  mixins: [validationMixin],
  validations: {
    form: {
      company: { required },
      address: { required },
      postalCode: { required, maxLength: maxLength(5) },
      city: { required },
      stateOrProvince: { required },
      countryCode: { required },
      companyId: { required },
      VATNumber: { required },
      SDI: { required },
      PEC: { required },
      IBAN: { required },
      email: {required}
    },
  },
  validationMessages: {
    form: {
      company: { required: "Choose your favorite animal" },
      address: { required: "Choose your favorite animal" },
      city: { required: "City is required" },
      stateOrProvince: { required: "State is required" },
      countryCode: { required: "Country is required" },
      companyId: { required: "CompanyID is required" },
      VATNumber: { required: "TAX Number is required" },
      SDI: { required: "SDI is required" },
      IBAN: { required: "IBAN is required" },
      email:{required: "Email is Required"},
      postalCode: {
        required: "PostalCode is required",
        maxLength: "Max 8 characters",
      },
    },
  },
  data() {
    return {
      page: "Settings",
      form: null,
      countries: availableCountries,
      form_hash:null,
      snackbar: false,     
      message:'',
      loading:false,
      loading_refresh:false,
      snackbar_color:'success', 
    };
  },
  computed: {
      ...mapGetters(["settings"]),
  },
  created(){
    this.getData()

    //console.log(716,this.user);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    /*
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    },
    assignedTable(newValue)
    {
      console.log(794,newValue)
      //this.assignedTables.push(newValue);
      console.log(796,newValue,this.assignedTables)
      this.assignTables(newValue);
    }*/
  },
  methods: {
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.form.reset();
      this.$v.$reset();
    },
    submit() {
      this.resetForm();
      this.$v.$reset();
    },
    save: _.debounce(function (event) {
        this.updateDB(event.target.name,event.target.value)
    }, 1000),
    async saveItems()
    {
        this.loading_update=true;
        console.log(255,this.form);
        let payload={"action":"saveItem","table":"Account","payload":JSON.stringify(this.form)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.getData();
        }   
    },     
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"date": this.date,"action":"Account_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                this.loading=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.form=res.data.payloads.account;
                    this.form_hash=JSON.stringify(this.form);  
                    console.log(315,this.form,this.form_hash)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    }, 
  },
};
</script>